import React from 'react';

const PageHeader = ({ title, subtitle }) => {
    return (
        <div className="bg-gradient-to-br from-orange-500 to-orange-600 text-white py-16 px-5 text-center">
            <h1 className="text-3xl md:text-4xl font-bold mb-3">{title}</h1>
            {subtitle && <p className="opacity-90 text-base max-w-xl mx-auto">{subtitle}</p>}
        </div>
    );
};

export default PageHeader;
